
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { 
  ResponsiveContainer, 
  BarChart as RechartsBarChart, 
  XAxis, 
  YAxis, 
  Bar, 
  Tooltip, 
  Legend, 
  CartesianGrid 
} from "recharts";

const AdminActivationStats: React.FC = () => {
  // Sample data - in a real app this would come from an API
  const activationData = [
    { month: "Jan", free: 4, basic: 2, premium: 1 },
    { month: "Feb", free: 3, basic: 3, premium: 2 },
    { month: "Mar", free: 5, basic: 3, premium: 1 },
    { month: "Apr", free: 2, basic: 4, premium: 3 },
    { month: "May", free: 6, basic: 5, premium: 3 },
    { month: "Jun", free: 8, basic: 4, premium: 4 },
  ];

  return (
    <Card className="border border-gray-200">
      <CardHeader className="pb-2">
        <CardTitle className="text-lg">Operator Activations</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="h-[300px]">
          <ResponsiveContainer width="100%" height="100%">
            <RechartsBarChart data={activationData}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} opacity={0.2} />
              <XAxis 
                dataKey="month" 
                fontSize={12} 
                tickMargin={10}
                stroke="#888"
              />
              <YAxis 
                fontSize={12}
                tickMargin={10}
                stroke="#888"
              />
              <Tooltip />
              <Legend />
              <Bar dataKey="free" fill="#CBD5E1" name="Free Plan" />
              <Bar dataKey="basic" fill="#33C3F0" name="Basic Plan" />
              <Bar dataKey="premium" fill="#F97316" name="Premium Plan" />
            </RechartsBarChart>
          </ResponsiveContainer>
        </div>
        <div className="mt-4 grid grid-cols-3 gap-4 text-center">
          <div>
            <p className="text-sm font-medium text-gray-600">Free Activations</p>
            <p className="text-2xl font-bold">28</p>
          </div>
          <div>
            <p className="text-sm font-medium text-gray-600">Basic Subscriptions</p>
            <p className="text-2xl font-bold">21</p>
          </div>
          <div>
            <p className="text-sm font-medium text-gray-600">Premium Subscriptions</p>
            <p className="text-2xl font-bold">14</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default AdminActivationStats;
